import { staffClient } from "common/apis/staff";
import { FileService } from "common/services/file";
import { infoService } from "common/services/info";
import SpinnerMedium from "components/Spinner/Medium";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ClinicEditForm from "common/pages/Clinic/EditForm";
import _ from "lodash";

const ClinicEditPage = () => {
    const { clinicId } = useParams();
    const [clinicInfo, setClinicInfo] = useState(null);

    // const [initialAddress, setInitialAddress] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchClinicInfo();
    }, [])

    const fetchClinicInfo = async () => {
        try {
            // const ret = await axios.get(`https://rest.miview.shop/clinic/${clinicId}`);
            const ret = await staffClient.get(`/clinic/${clinicId}`);
            console.log("[ClinicEditPage] fetchClinicInfo ret", ret);
            const clinicData = ret.data;
            setClinicInfo(clinicData);

            // setInitialAddress(clinicData.address);
        } catch (e) {
            console.log("[ClinicEditPage] fetchClinicInfo error", e);
        }
    }

    const onSave = async (formData) => {
        console.log("[ClinicEditPage] onSave", formData);
        try {
            // const ret = await axios.patch(`https://rest.miview.shop/clinic/${clinicId}`, formData);
            const uploadedProfileImage = await FileService.tryUploadFile(formData.profileImage);
            const uploadedBannerImage = await FileService.tryUploadFile(formData.bannerImage);
            const uploadedIntroductionImages = await FileService.tryUploadFiles(formData.introductionImages);
            const body = {
                ...formData,
                profileImage: uploadedProfileImage,
                bannerImage: uploadedBannerImage,
                introductionImages: uploadedIntroductionImages
            }
            const ret = await staffClient.patch(`/clinic/${clinicId}`, body);
            console.log("[ClinicEditPage] onSave ret", ret);
            infoService.fetchClinics();
            toast.success("의원 정보가 수정되었습니다.");
            navigate("/main/clinic");
        } catch (e) {
            console.log("[ClinicEditPage] onSave error", e);
            toast.error("의원 정보 수정 중 오류가 발생했습니다.");
        }
    }

    if (_.isNil(clinicInfo)) {
        return <SpinnerMedium />
    }

    return (
        <ClinicEditForm
            clinicInfo={clinicInfo}
            onSave={onSave}
        />
    )
}

export default ClinicEditPage;
